import { MouseEvent, ReactNode, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { useAuth } from '@context';
import { UserRoleService } from '@services';
import { InventorySKUListing } from '@views/StockBySKU/components/types';
import { SkuInfoModal } from './SkuInfoModal';

export interface SkuInfoLinkProps {
  sku?: InventorySKUListing | null;
  inventorySkuId?: string | null;
  children: ReactNode;
  className?: string;
}

export function SkuInfoLink({
  sku,
  inventorySkuId,
  children,
  className,
}: SkuInfoLinkProps) {
  const { user } = useAuth();
  const { isWarehouseClient } = UserRoleService();
  const [isOpen, setIsOpen] = useState(false);
  const [hasBeenOpened, setHasBeenOpened] = useState(false);

  const canOpenSkuDetails = sku
    ? true
    : Boolean(inventorySkuId) && isWarehouseClient(user);

  if (!canOpenSkuDetails) return <span className={className}>{children}</span>;

  const openSkuInfo = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setHasBeenOpened(true);
    setIsOpen(true);
  };

  return (
    <>
      <button
        type='button'
        onClick={openSkuInfo}
        title='View SKU details'
        className={twMerge(
          'max-w-full cursor-pointer truncate text-left text-blue-600 hover:text-blue-800 hover:underline',
          className
        )}
      >
        {children}
      </button>
      {hasBeenOpened && (
        <SkuInfoModal
          sku={sku}
          inventorySkuId={inventorySkuId}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
}
